interface SoundwaveProps {
  variant?: 'line' | 'underline' | 'dots';
  color?: string;
  className?: string;
}

export default function Soundwave({ variant = 'line', color = '#40E0D0', className = '' }: SoundwaveProps) {
  if (variant === 'dots') {
    return (
      <div className={`flex items-center gap-[3px] ${className}`}>
        <div className="w-[3px] h-[3px] rounded-full bg-current animate-pulse-dot" style={{ color, animationDelay: '0ms' }}></div>
        <div className="w-[3px] h-[3px] rounded-full bg-current animate-pulse-dot" style={{ color, animationDelay: '150ms' }}></div>
        <div className="w-[3px] h-[3px] rounded-full bg-current animate-pulse-dot" style={{ color, animationDelay: '300ms' }}></div>
      </div>
    );
  }

  if (variant === 'underline') {
    return (
      <svg
        className={`w-full h-[2px] ${className}`}
        viewBox="0 0 100 4"
        preserveAspectRatio="none"
        style={{ opacity: 0.3 }}
      >
        <path
          d="M0,2 Q5,0.5 10,2 T20,2 T30,2 T40,2 T50,2 T60,2 T70,2 T80,2 T90,2 T100,2"
          stroke={color}
          strokeWidth="1"
          fill="none"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    );
  }

  return (
    <svg
      className={`w-full h-[40px] ${className}`}
      viewBox="0 0 200 40"
      preserveAspectRatio="none"
    >
      <defs>
        <linearGradient id="soundwave-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopOpacity="0" />
          <stop offset="15%" stopOpacity="0.22" />
          <stop offset="85%" stopOpacity="0.22" />
          <stop offset="100%" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path
        d="M0,20 L5,18 L10,22 L15,15 L20,25 L25,12 L30,28 L35,10 L40,30 L45,8 L50,32 L55,14 L60,26 L65,16 L70,24 L75,18 L80,22 L85,20 L90,20 L95,19 L100,21 L105,18 L110,22 L115,16 L120,24 L125,14 L130,26 L135,12 L140,28 L145,10 L150,30 L155,15 L160,25 L165,17 L170,23 L175,19 L180,21 L185,20 L190,20 L195,20 L200,20"
        stroke={color}
        strokeWidth="1"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
        style={{ opacity: 1 }}
        strokeOpacity="url(#soundwave-gradient)"
      />
    </svg>
  );
}
